import React from "react";
import { Button } from "@mui/material";

export default function ButtonToIndex({
  activeType,
  projectIndexUrl,
  jobIndexUrl,
}) {
  const isProjects = activeType === "projects";
  const label = isProjects ? "プロジェクト一覧" : "求人一覧";
  const href = isProjects ? projectIndexUrl : jobIndexUrl;

  return (
    <Button
      component="a"
      href={href}
      sx={{
        color: "white",
        fontSize: {
          xs: "14px",
        },
        fontWeight: "bold",
        backgroundColor: "#4444DC",
        borderRadius: "5px",
        px: "70px",
        py: "10px",
        display: "block",
        textAlign: "center",
        "&:hover": { backgroundColor: "#3B3BE0" },
      }}
    >
      {label}
    </Button>
  );
}
